import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import { RESOURCES } from '@/data/endpoints';
import { nexusColors } from '@/theme';

export function AppHeader(): JSX.Element {
  const [open, setOpen] = useState(false);

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{ bgcolor: 'rgba(11,11,19,0.86)', backdropFilter: 'blur(10px)', borderBottom: `1px solid ${nexusColors.line}` }}
    >
      <Toolbar sx={{ gap: 2, minHeight: 68 }}>
        <Box component={RouterLink} to="/" sx={{ display: 'flex', alignItems: 'center', gap: 1, textDecoration: 'none' }}>
          <Box component="img" src="/brand/nexus-mark.svg" alt="" sx={{ height: 28, width: 28 }} />
          <Box sx={{ fontFamily: '"Space Grotesk", sans-serif', fontWeight: 700, fontSize: 18, color: nexusColors.ink }}>
            NexusRMM <Box component="span" sx={{ color: nexusColors.purpleLight }}>API</Box>
          </Box>
        </Box>

        <Box sx={{ flex: 1 }} />

        <Stack direction="row" spacing={1} sx={{ display: { xs: 'none', md: 'flex' } }}>
          <Button component={RouterLink} to="/authentication" size="small" sx={{ color: nexusColors.muted, '&:hover': { color: nexusColors.ink } }}>
            Authentication
          </Button>
          <Button component="a" href="https://wiki.nexusrmm.ai" size="small" variant="outlined" sx={{ borderColor: nexusColors.line, color: nexusColors.ink }}>
            Wiki
          </Button>
        </Stack>

        <IconButton aria-label="Open navigation" onClick={() => setOpen(true)} sx={{ display: { xs: 'inline-flex', md: 'none' }, color: nexusColors.ink }}>
          <MenuIcon />
        </IconButton>
      </Toolbar>

      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 280, bgcolor: nexusColors.bgElevated, height: '100%', pt: 2 }}>
          <List>
            <ListItemButton component={RouterLink} to="/authentication" onClick={() => setOpen(false)}>
              <ListItemText primary="Authentication" />
            </ListItemButton>
            {RESOURCES.map((r) => (
              <ListItemButton key={r.id} component={RouterLink} to={`/${r.slug}`} onClick={() => setOpen(false)}>
                <ListItemText primary={r.name} />
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
}
